// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Number';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>
        Refers to the number of individual accent diamonds present in a group of
        diamonds of the same shape and size.
      </p>
    </div>
  );
}
